// extracted by mini-css-extract-plugin
export default {"modal":"Login_modal__nr6qg","subtitle":"Login_subtitle__GCyie"};